<template>
  <div class="products-section" ref="productsSection">
    <div class="content m-top-5 m-bot-6">
      <div class="column first">
        <NuxtLink
          :to="
            localePath({
              name: props.navigation.globalSets[1].navigationPages[0].key,
            })
          "
          class="title-medium pagina underline-hover"
        >
          <span>{{
            props.navigation.globalSets[1].navigationPages[0].title
          }}</span>
        </NuxtLink>

        <NuxtLink
          v-for="(link, index) in filteredCategories"
          :key="index"
          :to="
            localePath({
              name: 'vino-slug',
              params: { slug: link.slug },
            })
          "
          class="categoria underline-hover"
        >
          <span class="text-big">{{ link.title }}</span>
        </NuxtLink>
      </div>
      <div class="column second">
        <NuxtLink
          v-for="(
            link, index
          ) in props.navigation.globalSets[1].navigationPages.slice(1)"
          :key="index"
          class="title-medium underline-hover"
          :to="localePath(link.key)"
        >
          <span>{{ link.title }}</span>
        </NuxtLink>
      </div>
      <div class="column third">
        <span class="text-big">{{ $t('navigation.comeFarePer') }}</span>
        <NuxtLink
          v-for="(link, index) in props.navigation.comeFarePerEntries"
          :key="index"
          class="text-base underline-hover"
          :to="
            localePath({
              name: 'come-fare-per-slug',
              params: { slug: link.slug },
            })
          "
        >
          <span>{{ link.title }}</span>
        </NuxtLink>
        <NuxtLink :to="localePath({ name: 'risorse' })">
          <div class="text-small3 default-icon-btn">
            <span v-html="$t('common.seeAll')" />
            <ArrowIcon alt="Arrow icon" class="icon-arrow" />
          </div>
        </NuxtLink>
      </div>
      <div v-if="props.navigation.globalSets[0]" class="column detached">
        <div class="wrapper">
          <NuxtLink
            class="text-base"
            :to="localePath(props.navigation.globalSets[0].highlightUrl)"
          >
            <div class="img-container">
              <WidgetPicture
                class="highlight-img"
                :image="{
                  portrait: props.navigation.globalSets[0].portrait[0],
                }"
                :alt="props.navigation.globalSets[0].portrait[0].title"
              />
            </div>
            <div class="txt-container">
              <span class="text-medium">
                {{ props.navigation.globalSets[0].highlightTitle }}
              </span>
              <!--
              <img
                alt="Arrow icon"
                src="@/assets/img/ico/arrow-purple.svg?url"
                class="icon-arrow"
              />
              -->
              <ArrowIconsDesk alt="Arrow icon" class="icon-arrow" />
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'
import ArrowIconsDesk from '@/assets/img/ico/arrow-purple.svg'
import { gsap } from 'gsap'

const props = defineProps({
  showProductsSection: Boolean,
  navigation: Object,
})

const productsSection = ref(null)

const filteredCategories = computed(() => {
  return props.navigation.categories.filter((category) => {
    return category.slug && category.title
  })
})

watch(
  () => props.showProductsSection,
  (newVal) => {
    if (productsSection.value) {
      const sectionHeight = productsSection.value.offsetHeight

      if (newVal) {
        gsap.set(productsSection.value, {
          y: `-${sectionHeight}px`,
          autoAlpha: 1,
        })
        gsap.to(productsSection.value, {
          y: '0px',
          backgroundColor: '#ffffff',
          ease: 'power2.inOut',
          duration: 0.5,
        })
      } else {
        gsap.to(productsSection.value, {
          y: `-${sectionHeight}px`,
          backgroundColor: '#f3f3f3',
          ease: 'power2.inOut',
          duration: 0.5,
          autoAlpha: 0,
        })
      }
    }
  },
)
</script>

<script>
export default {
  name: 'ProductsSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
